import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  addApplyLeaveOrWHFApi,
  addClientIdPasswordManagerApi,
  addGstRegisterBusinessApi,
  addIdPasswordManagerApi,
  deleteIdPasswordManagerApi,
  deleteUpcomingLeaveApi,
  editClientIdPasswordManagerApi,
  editIdPasswordManagerApi,
  getClientIdPasswordManagerApi,
  getIdPasswordManagerApi,
  getLeaveHistoryListApi,
  getSingleLeaveApi,
  getTokenGenerateForDownloadApi,
  isGstRegisteredVerifyApi,
  leaveStatusChangeApi,
  updateApplyLeaveOrWHFApi,
  uploadFilesApi,
} from "../../apis/stcoToolsApi";
import {
  AddGstRegisterBusinessPayloadType,
  AddIdPasswordManagerPayloadType,
  ApplyLeaveFormType,
  DeleteIdPasswordManagerPayloadType,
  DeleteUpcomingLeavePayload,
  GetClientIdPasswordManagerListPayloadType,
  GetGenerateSasTokenPayloadType,
  GetIdPasswordManagerListPayloadType,
  IsGstRegisteredVerifyPayloadType,
  LeaveAndWFHListPayloadType,
  LeaveAndWFHStatusPayload,
  SingleApplyPayload,
  UpdateIdPasswordManagerPayloadType,
  UploadFilePayloadType,
} from "../../commonTypes/stcoToolsType";

//User Id Password Manager
export const getIdPasswordManagerListAction = createAsyncThunk(
  "stcoTools/getIdPasswordManagerList",
  async (data: GetIdPasswordManagerListPayloadType) => {
    const response = await getIdPasswordManagerApi(data);
    return response.data;
  }
);

export const addIdPasswordManagerAction = createAsyncThunk(
  "stcoTools/addIdPasswordManager",
  async (data: AddIdPasswordManagerPayloadType) => {
    const response = await addIdPasswordManagerApi(data);
    return response.data;
  }
);

export const editIdPasswordManagerAction = createAsyncThunk(
  "stcoTools/editIdPasswordManager",
  async (data: UpdateIdPasswordManagerPayloadType) => {
    const response = await editIdPasswordManagerApi(data);
    return response.data;
  }
);
export const deleteIdPasswordManagerAction = createAsyncThunk(
  "stcoTools/deleteIdPasswordManager",
  async (data: DeleteIdPasswordManagerPayloadType) => {
    const response = await deleteIdPasswordManagerApi(data);
    return response.data;
  }
);

//Client Id Password Manager

export const getClientIdPasswordManagerListAction = createAsyncThunk(
  "stcoTools/clientIdPasswordMangerList",
  async (data: GetClientIdPasswordManagerListPayloadType) => {
    const response = await getClientIdPasswordManagerApi(data);
    return response;
  }
);

export const addClientIdPasswordManagerAction = createAsyncThunk(
  "stcoTools/addClientIdPasswordManager",
  async (data: AddIdPasswordManagerPayloadType) => {
    const response = await addClientIdPasswordManagerApi(data);
    return response.data;
  }
);

export const editClientIdPasswordManagerAction = createAsyncThunk(
  "stcoTools/editClientIdPasswordManager",
  async (data: UpdateIdPasswordManagerPayloadType) => {
    const response = await editClientIdPasswordManagerApi(data);
    return response.data;
  }
);

export const getLeaveAndWFHListAction = createAsyncThunk(
  "stcoTools/getLeaveHistoryList",
  async (data: LeaveAndWFHListPayloadType) => {
    const response = await getLeaveHistoryListApi(data);
    return response.data;
  }
);

export const getUpcomingListAction = createAsyncThunk(
  "stcoTools/getUpcomingList",
  async (data: LeaveAndWFHListPayloadType) => {
    const response = await getLeaveHistoryListApi(data);
    return response.data;
  }
);
export const applyLeaveOrWHFAction = createAsyncThunk(
  "stcoTools/applyLeaveOrWHFAction",
  async (data: ApplyLeaveFormType) => {
    const response = await addApplyLeaveOrWHFApi(data);
    return response.data;
  }
);

export const getSingleLeaveAction = createAsyncThunk(
  "stcoTools/getSingleLeaveAction",
  async (data: SingleApplyPayload) => {
    const response = await getSingleLeaveApi(data);
    return response.data;
  }
);

export const updateApplyLeaveOrWHFAction = createAsyncThunk(
  "stcoTools/updateApplyLeaveOrWHFAction",
  async (data: ApplyLeaveFormType) => {
    const response = await updateApplyLeaveOrWHFApi(data);
    return response.data;
  }
);

export const deleteUpcomingLeave = createAsyncThunk(
  "stcoTools/deleteUpcomingLeaveAction",
  async (data: DeleteUpcomingLeavePayload) => {
    const response = await deleteUpcomingLeaveApi(data);
    return response.data;
  }
);

export const leaveAndWFHApprovedStatusAction = createAsyncThunk(
  "stcoTools/leaveAndWFHApprovedStatusActionAction",
  async (data: LeaveAndWFHStatusPayload) => {
    const response = await leaveStatusChangeApi(data);
    return response.data;
  }
);
export const leaveAndWFHRejectStatusAction = createAsyncThunk(
  "stcoTools/leaveAndWFHRejectStatusActionAction",
  async (data: LeaveAndWFHStatusPayload) => {
    const response = await leaveStatusChangeApi(data);
    return response.data;
  }
);

export const addGstRegisterBusinessAction = createAsyncThunk(
  "stcoTools/addGstRegisterBusinessAction",
  async (data: AddGstRegisterBusinessPayloadType) => {
    const response = await addGstRegisterBusinessApi(data);
    return response.data;
  }
);
export const isGstRegisteredVerifyAction = createAsyncThunk(
  "stcoTools/isGstRegisteredVerifyAction",
  async (data: IsGstRegisteredVerifyPayloadType) => {
    const response = await isGstRegisteredVerifyApi(data);
    return response.data;
  }
);

// Upload File Action
export const uploadFilesAction = createAsyncThunk(
  "stcoTools/fileUpload",
  async (files: UploadFilePayloadType) => {
    const response = await uploadFilesApi(files);
    return response.data;
  }
);


export const getTokenGenerateForDownloadAction = createAsyncThunk(
  "stcoTools/getToken",
  async (data: GetGenerateSasTokenPayloadType) => {
    const response = await getTokenGenerateForDownloadApi(data);
    return response.data;
  }
);
